import React, { useState } from "react";
import {
  FaArrowRight,
  FaBars,
  FaBriefcase,
  FaCalendarAlt,
  FaChartBar,
  FaGlobeAmericas,
  FaHandshake,
  FaLandmark,
  FaLightbulb,
  FaMapMarkerAlt,
  FaSeedling,
  FaTimes,
  FaUsers,
} from "react-icons/fa";
import "./style.css";
import londonBackground from "../../assets/forum-london/london-background.jpg";
import greenEnergy from "../../assets/forum-london/green-energy.png";
import miningSector from "../../assets/forum-london/mining-sector.png";
import investmentLandscape from "../../assets/forum-london/investment-landscape.png";
import emblem from "../../assets/img/EmblemTj.svg";
import tajinvestLogo from "../../assets/img/tajinvestSmall2.png";

const registrationUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSeUpAAEhTCyFgLLO4dFsShlB6cAdcTXNsll3Z27lewmMJsEOg/viewform?usp=publish-editor";

const navItems = [
  ["Home", "home"],
  ["About", "about"],
  ["Agenda", "agenda"],
  ["Themes", "themes"],
  ["Register", "register"],
];

const agenda = [
  [
    "13:00",
    "Norton Rose Fulbright Seminar",
    "Seminar hosted by Norton Rose Fulbright",
  ],
  ["15:00", "Opening Remarks", "Welcome and introduction "],
  ["15:20", "Keynote Address", "Tajikstan's vision for a prosperous furure"],
  [
    "15:50",
    "Panel I: Tajikistan's Energy Sector - Green Investment Opportunities",
    "Opportunties, projects and partnerships",
  ],
  ["16:50", "Networking Session", "Refreshments and B2B meetings"],
  [
    "17:20",
    "Panel II: Developing Tajikistan's Mining Sector",
    "Resouces, investment and sustatinable development",
  ],
  ["18:20", "Networking Session", "B2B meetings and engagement"],
  [
    "18:50",
    "Panel III: Tajikistan's Investment Landscape",
    "Busniess climate, priority and next steps",
  ],
  ["19:50", "Gala Dinner", "Hosted dinner and networking"],
];

const ForumLondon = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const scrollTo = (id) => {
    setMenuOpen(false);
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // some change

  return (
    <main className="fl-page">
      <header className="fl-header">
        <a
          className="fl-organizer"
          href="/"
          aria-label="State Committee on Investments and State Property Management"
        >
          <img src={emblem} alt="State Committee emblem" />
          <span>
            State Committee on Investment
            <br />
            and State Property Management
            <br />
            of the Republic of Tajikistan
          </span>
        </a>
        <button
          className="fl-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
        <nav className={menuOpen ? "fl-nav fl-nav-open" : "fl-nav"}>
          {navItems.map(([label, id]) =>
            id === "home" ? (
              <a key={id} href="/">
                {label}
              </a>
            ) : (
              <button key={id} onClick={() => scrollTo(id)}>
                {label}
              </button>
            ),
          )}
        </nav>
        <a className="fl-tajinvest" href="/" aria-label="Tajinvest">
          <img src={tajinvestLogo} alt="" />
          <span>TAJINVEST</span>
        </a>
      </header>

      <section className="fl-hero">
        <img
          src={londonBackground}
          className="fl-hero-image"
          alt="London and the Houses of Parliament"
        />
        <div className="fl-hero-shade" />
        <div className="fl-container fl-hero-content">
          <p className="fl-kicker">
            Presentation on Tajikistan’s investment potential
          </p>
          <h1>
            Tajikistan Investment
            <br />
            Forum in London
          </h1>
          <div className="fl-meta">
            <span>
              <FaCalendarAlt /> 9 December 2026
            </span>
            <i />
            <span>
              <FaMapMarkerAlt /> London, United Kingdom
            </span>
          </div>
          <p className="fl-hero-copy">
            Connecting government leaders, investors, financial institutions and
            businesses to explore investment opportunities in Tajikistan.
          </p>
          <a
            className="fl-button"
            href={registrationUrl}
            target="_blank"
            rel="noreferrer"
          >
            Join delegation <FaArrowRight />
          </a>
          <p className="fl-values">
            People <b>•</b> Partnerships <b>•</b> Prosperity
          </p>
        </div>
      </section>

      <section id="about" className="fl-section fl-about">
        <div className="fl-container">
          <SectionTitle>About the Forum</SectionTitle>
          <p className="fl-lead">
            The Tajikistan Investment Forum in London brings together government
            officials, private sector leaders, international financial
            institutions, investors and industry experts from Tajikistan and the
            UK to explore investment opportunities and build lasting
            partnerships.
          </p>
          <div className="fl-feature-grid">
            <Feature
              icon={<FaLandmark />}
              title="Government & Business"
              text="Dialogue between government officials and the private sector."
            />
            <Feature
              icon={<FaChartBar />}
              title="Investment Projects"
              text="Showcasing priority projects across key sectors."
            />
            <Feature
              icon={<FaUsers />}
              title="B2B Networking"
              text="Meaningful connections and new opportunities."
            />
            <Feature
              icon={<FaHandshake />}
              title="Strategic Partnerships"
              text="Building long-term, mutually beneficial partnerships."
            />
          </div>
        </div>
      </section>

      <section id="themes" className="fl-section fl-themes">
        <div className="fl-container">
          <SectionTitle>Key Investment Themes</SectionTitle>
          <div className="fl-themes-grid">
            <ThemeCard
              image={greenEnergy}
              icon={<FaSeedling />}
              title="Green Energy"
              text="Hydropower, infrastructure and green investment opportunities."
            />
            <ThemeCard
              image={miningSector}
              icon={<FaBriefcase />}
              title="Mining"
              text="Developing Tajikistan’s mining sector and attracting international partners."
            />
            <ThemeCard
              image={investmentLandscape}
              icon={<FaChartBar />}
              title="Investment Landscape"
              text="Priority projects, business climate and cross-sector opportunities."
            />
          </div>
        </div>
      </section>

      <section id="agenda" className="fl-section fl-agenda">
        <div className="fl-container">
          <SectionTitle>Forum Agenda</SectionTitle>
          <div className="fl-agenda-list">
            {agenda.map(([time, title, text], index) => (
              <div className="fl-agenda-row" key={title}>
                <time>{time}</time>
                <span className="fl-agenda-dot" aria-hidden="true" />
                <div className="fl-agenda-title">{title}</div>
                <div className="fl-agenda-description">{text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="fl-section fl-attend">
        <div className="fl-container">
          <SectionTitle>Who Should Attend?</SectionTitle>
          <div className="fl-attend-grid">
            <Attend icon={<FaChartBar />} label="Investors & Funds" />
            <Attend icon={<FaLandmark />} label="Financial Institutions" />
            <Attend icon={<FaUsers />} label="Corporates & Industry Leaders" />
            <Attend
              icon={<FaGlobeAmericas />}
              label="Government & Development Institutions"
            />
            <Attend
              icon={<FaLightbulb />}
              label="Entrepreneurs & Business Leaders"
            />
          </div>
        </div>
      </section>

      <section id="register" className="fl-mission">
        <img src={londonBackground} alt="London bridge" />
        <div className="fl-mission-overlay" />
        <div className="fl-container fl-mission-content">
          <div>
            <h2>Business Mission to London</h2>
            <div className="fl-meta">
              <span>
                <FaCalendarAlt /> 8 – 10 December 2026
              </span>
              <i />
              <span>
                <FaMapMarkerAlt /> London, United Kingdom
              </span>
            </div>
            <p>
              Join the wider Tajikistan business mission featuring B2B meetings,
              institutional visits and a cultural programme.
            </p>
          </div>
          <div className="fl-mission-cta">
            <span>
              Be Part of
              <br />
              <strong>
                Tajikistan’s Business
                <br />
                Delegation
              </strong>
            </span>
            <a
              className="fl-button"
              href={registrationUrl}
              target="_blank"
              rel="noreferrer"
            >
              Join delegation <FaArrowRight />
            </a>
          </div>
        </div>
      </section>

      <footer className="fl-footer">
        <div className="fl-container">
          <div>
            <strong>
              Organised by the State Committee on Investment and State Property
              Management
            </strong>
            <br />
            of the Republic of Tajikistan and SUE “Tajinvest”
          </div>
          <div className="fl-footer-contact">
            info@tajinvest.tj &nbsp; | &nbsp; (+992) 988 71 13 05
          </div>
        </div>
        <div className="fl-footer-bottom fl-container">
          © 2026 Tajikistan Investment Forum. All rights reserved.
        </div>
      </footer>
    </main>
  );
};

const SectionTitle = ({ children }) => <h2 className="fl-title">{children}</h2>;
const Feature = ({ icon, title, text }) => (
  <article className="fl-feature">
    <div>{icon}</div>
    <h3>{title}</h3>
    <p>{text}</p>
  </article>
);
const ThemeCard = ({ image, icon, title, text }) => (
  <article className="fl-theme-card">
    <img src={image} alt="" />
    <div className="fl-theme-body">
      <span className="fl-theme-icon">{icon}</span>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  </article>
);
const Attend = ({ icon, label }) => (
  <article className="fl-attend-card">
    <span>{icon}</span>
    <h3>{label}</h3>
  </article>
);

export default ForumLondon;
